import {client} from '../helpers/api';

export async function postEditProfile({
  contactNumber,
  fullName,
  gradeId,
  momContact,
  dadContact,
  schoolName,
  schoolType,
}) {
  const body = {
    full_name: fullName,
    contact_number: contactNumber,
    grade_id: gradeId,
    mom_contact: momContact,
    dad_contact: dadContact,
    school_name: schoolName,
    school_type: schoolType,
  };

  const response = await client.post('/auth/edit-profile', body);

  if (response.data?.status) {
    return response.data?.message || '';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
